module.exports = __webpack_public_path__ + "static/media/feature.0969c418.jpg";